const session = {
  SIGN_IN: '/totem/v2/signin',
  SIGN_OUT: '/totem/v1/signout',
} as const

const building = {
  MACHINES: '/totem/v2/building/machines',
  PRICING: '/totem/v2/building/pricing',
} as const

const order = {
  ORDER: '/totem/v2/order',
  ORDER_ITEMS: '/totem/v2/order/items',
  ORDER_NEXT: '/totem/v2/order/next',
} as const

export const endpoints = {
  ...session,
  ...building,
  ...order,
}
